module.exports = __webpack_public_path__ + "static/img/jcdldr.49be2203.png";